import { alpha, styled } from "@mui/material/styles";

export const StyledRootScrollbar = styled("div")(() => ({
  flexGrow: 1,
  height: "100%",
  overflow: "hidden",
}));

export const StyledScrollbar = styled("div")(({ theme }) => ({
  height: "100%",
  maxHeight: "100%",
  overflowX: "hidden",
  overflowY: "auto",
  scrollbarColor: `${alpha(theme.palette.grey[600], 0.48)} transparent`,
  scrollbarWidth: "thin",
  "&::-webkit-scrollbar": {
    width: 10,
    height: 6,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: alpha(theme.palette.grey[600], 0.48),
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
}));
